
export default function GraphUp({stroke='#495057', width='18',height='12'}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6 0.5L14.661 2.59917L10.269 7.0725L6.669 3.40583L0 10.2075L1.269 11.5L6.669 6L10.269 9.66667L15.939 3.90083L18 6V0.5H12.6Z"
        fill={stroke}
      />
    </svg>
  );
}
